import { render, staticRenderFns } from "./miniappPannelCate.vue?vue&type=template&id=5dba4c77"
import script from "./miniappPannelCate.vue?vue&type=script&lang=js"
export * from "./miniappPannelCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports